import { PROVIDERS } from '../enum/providers/providers';

export const IsValidRight = (pData: any, pRigth: PROVIDERS[]): boolean =>
  pData && pData.rights && pData.rights.find((x: any) => pRigth.indexOf(x.id) != -1);
